(() => {
  /* [(+)] ★★★★★★★★★★ Evitar múltiples inicializaciones ★★★★★★★★★★ [(+)] */
  if (window.__stickyVariantSyncInitialized) return;

  window.__stickyVariantSyncInitialized = true;

  /* [(+)] ★★★★★★★★★★ Cache DOM estable ★★★★★★★★★★ [(+)] */
  const sticky = document.querySelector('.pd-sticky-atc');

  if (!sticky) return;

  const stickyImage = sticky.querySelector('.pd-sticky-atc__image');
  const stickyVariantName = sticky.querySelector('.pd-sticky-atc__variant-name');
  const stickyPriceWrapper = sticky.querySelector('.pd-sticky-atc__price-wrapper');
  const stickyPrice = sticky.querySelector('.pd-sticky-atc__price');
  const stickyCompareAtPrice = sticky.querySelector('.pd-sticky-atc__compare-at-price');
  const stickyDiscountBadge = sticky.querySelector('.pd-sticky-atc__discount-badge');
  const stickyButton = sticky.querySelector('.pd-sticky-atc__button');
  const moneyFormatter = new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
  });

  /* [(+)] ★★★★★★★★★★ Listener sticky button ★★★★★★★★★★ [(+)] */
  stickyButton.addEventListener('click', () => {
    const originalAddToCartBtn = document.querySelector('.product--add-to-cart-button');

    if (!originalAddToCartBtn || originalAddToCartBtn.disabled) return;

    originalAddToCartBtn.click();
  });

  /* [(+)] ★★★★★★★★★★ Helpers ★★★★★★★★★★ [(+)] */
  const getActiveSwatch = () => {
    return document.querySelector('input[name="id"]');
  };

  const getVariantId = (swatch) => {
    if (!swatch) return null;

    return swatch.value;
  };

  /* [(+)] ★★★★★★★★★★ Baseline inicial ★★★★★★★★★★ [(+)] */
  let currentVariantId = getVariantId(getActiveSwatch());

  /* [(+)] ★★★★★★★★★★ Sync ★★★★★★★★★★ [(+)] */
  const syncSticky = () => {
    const activeSwatch = getActiveSwatch();

    if (!activeSwatch) return;

    const nextVariantId = getVariantId(activeSwatch);

    if (!nextVariantId) return;

    /* [CAMBIO] El botón puede cambiar de estado SIN cambio de variante. */
    syncStickyButtonState();

    /* [(+)] ★★★★★★★★★★ No hubo cambio ★★★★★★★★★★ [(+)] */
    if (nextVariantId === currentVariantId) return;

    /* [(+)] ★★★★★★★★★★ Actualizar baseline ★★★★★★★★★★ [(+)] */
    currentVariantId = nextVariantId;

    /* [(+)] ★★★★★★★★★★ Obtener datos ★★★★★★★★★★ [(+)] */
    const variantDataElement = document.querySelector(`.swatch-element[data-swatch-variant-id="${activeSwatch.value}"] + script`);

    if (!variantDataElement) return;

    const variant = JSON.parse(variantDataElement.textContent);

    /* [(+)] ★★★★★★★★★★ Actualizar UI ★★★★★★★★★★ [(+)] */
    updateStickyUI(variant);
  };

  /* [(+)] ★★★★★★★★★★ Sticky button state sync ★★★★★★★★★★ [(+)] */
  const syncStickyButtonState = () => {
    const originalAddToCartBtn = document.querySelector('.product--add-to-cart-button');

    if (!originalAddToCartBtn) return;

    /* [CAMBIO] Sync disabled state */
    stickyButton.disabled = originalAddToCartBtn.disabled;

    /* [CAMBIO] Sync texto */
    const originalButtonText = originalAddToCartBtn.querySelector('[data-add-to-cart-text]');
    const stickyButtonText = stickyButton.querySelector('.pd-sticky-atc__button-text');

    if (originalButtonText && stickyButtonText) {
      stickyButtonText.textContent = originalButtonText.textContent;

      /* Sync display state */
      stickyButtonText.style.display = originalButtonText.style.display;
    }

    /* [CAMBIO] Sync spinner */
    const originalSpinner = originalAddToCartBtn.querySelector('svg');
    const stickySpinner = stickyButton.querySelector('svg');
    const stickyCartIcon = stickyButton.querySelector('.pd-sticky-atc__button-icon-cart');

    if (originalSpinner && stickySpinner) {
      if (originalSpinner.classList.contains('hidden')) {
        stickySpinner.classList.add('hidden');
        stickyCartIcon.classList.remove('hidden');
      } else {
        stickySpinner.classList.remove('hidden');
        stickyCartIcon.classList.add('hidden');
      }
    }
  };

  /* [(+)] ★★★★★★★★★★ UI Update ★★★★★★★★★★ [(+)] */
  const updateStickyUI = (variant) => {
    if (!variant) return;

    /* [(+)] ★★★★★★★★★★ Variant name ★★★★★★★★★★ [(+)] */
    if (stickyVariantName && variant.title) {
      stickyVariantName.textContent = variant.title;
    }

    /* [(+)] ★★★★★★★★★★ Price ★★★★★★★★★★ [(+)] */
    if (stickyPrice && variant.price != null) {
      stickyPrice.textContent = moneyFormatter
        .format(variant.price / 100)
        .replace('$', '$ ');
    }

    if (stickyCompareAtPrice && variant.compare_at_price != null) {
      stickyCompareAtPrice.textContent = moneyFormatter
        .format(variant.compare_at_price / 100)
        .replace('$', '$ ');
    }

    if (variant.price < variant.compare_at_price) {
      stickyPriceWrapper.classList.add('pd-sticky-atc__price--on-sale');
    } else {
      stickyPriceWrapper.classList.remove('pd-sticky-atc__price--on-sale');
    }

    const discountBadge = (variant.compare_at_price - variant.price) * 100 / variant.compare_at_price;

    stickyDiscountBadge.textContent = `-${discountBadge}% off`;

    /* [(+)] ★★★★★★★★★★ Image ★★★★★★★★★★ [(+)] */
    if (stickyImage && variant.featured_media?.preview_image?.src) {
      stickyImage.src = variant.featured_media.preview_image.src;
    }

    /* [(+)] ★★★★★★★★★★ Botón ★★★★★★★★★★ [(+)] */
    const originalAddToCartBtn = document.querySelector('.product--add-to-cart-button');

    if (originalAddToCartBtn.disabled === true) {
      stickyButton.disabled = true;
    } else {
      stickyButton.disabled = false;
    }

    stickyButton.querySelector('.pd-sticky-atc__button-text').textContent = originalAddToCartBtn.querySelector('[data-add-to-cart-text]').textContent;
  };

  /* [(+)] ★★★★★★★★★★ Polling ★★★★★★★★★★ [(+)]*/
  setInterval(syncSticky, 100);
})();

/* [(+)] ★★★★★★★★★★ Mostrar / ocultar Sticky ★★★★★★★★★★ [(+)]*/
const isElementInViewport = (el) => {
  if (!el) return false;
  const rect = el.getBoundingClientRect();
  return (
    rect.bottom > 0 && rect.top < (window.innerHeight || document.documentElement.clientHeight)
  );
}

const productATCForm = document.querySelector('.product--add-to-cart-form');
const footerWrapper = document.querySelector('.footer-wrapper');
const pdStickyATC = document.querySelector('.pd-sticky-atc');

const handleStickyButton = () => {
  const productATCFormVisible = isElementInViewport(productATCForm);
  const footerWrapperVisible = isElementInViewport(footerWrapper);

  if (!productATCFormVisible && !footerWrapperVisible) {
    pdStickyATC.classList.add('pd-sticky-atc--visible');
  } else {
    pdStickyATC.classList.remove('pd-sticky-atc--visible');
  }
}

let stickyTicking = false;

const onStickyScroll = () => {
  if (stickyTicking) return;

  stickyTicking = true;

  requestAnimationFrame(() => {
    handleStickyButton();

    stickyTicking = false;
  });
}

window.addEventListener('scroll', onStickyScroll);
